<template>
    <div id="newResidual">
        <el-row class="clearfix" style="margin-bottom: 15px;">
            <el-col class="fl" :span="2">
                <el-button size="small"  type="warning" @click="backGo()">返回</el-button>
            </el-col>
            <el-col class="fr" :span="1">
                <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
            </el-col>
        </el-row>
        <el-col class="fl searthPart" style="width: 17%;">
            <p class="headerT">残值信息</p>
            <el-form ref="returnForm" :model="returnForm" label-width="80px" :label-position="labelPosition">
                <el-form-item label="残值单号">
                    <el-input :disabled="true" v-model="returnForm.scrapValueCode"></el-input>
                </el-form-item>
                <el-form-item label="操作类型">
                    <el-input :disabled="true" v-model="returnForm.operatorName"></el-input>
                </el-form-item>
                <el-form-item label="操作人">
                    <el-input :disabled="true" v-model="returnForm.createName" ></el-input>
                </el-form-item>
                <el-form-item label="提交时间">
                    <el-input :disabled="true" v-model="returnForm.updateTime" ></el-input>
                </el-form-item>
            </el-form>
        </el-col>
        <el-col class="fr" style="width: 81%;">
            <el-table
                :data="returnData"
                border
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
                <el-table-column
                    align="center"
                    type="index"
                    width="50"
                    label="序号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="code"
                    width="150"
                    label="序列号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="materialCode"
                    label="物料编号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="modelName"
                    label="型号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="materialName"
                    label="物料名称">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="forecastValue"
                    width="200"
                    label="预估残值">
                </el-table-column>
            </el-table>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
            <div class="totalDiv">
                <small>数量：</small>
                <strong >{{totalCount}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;
                <span>
                    <small >总计：</small>
                    <strong >{{totalMoney}}</strong> 元
                </span>
            </div>
        </el-col>
    </div>
</template>

<script>
    let moment = require("moment");
    import clip from '@/util/clipboard'
    import {
        wasteInfo,
        wasteInfoList
    } from "../../../api/api";
    export default {
        name: 'newResidual',
        components: {},
        data () {
            return {
                totalCount:0,           //物料总数量
                totalMoney:0,           //总金额
                orderId:'',
                materialParams:{
                    number:''        //物料序列号字符串
                },
                labelPosition:'left',
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                returnForm:{
                    operatorName:'废料残值',
                    operatorType:1,   //废料残值
                    scrapValueCount:'',//残值数量
                    createUser:'',
                    scrapValueDetails:[
                        {
                            code:'',
                            materialCode:'',
                            materialName:'',
                            modelId:'',
                            forecastValue:'',
                            memo:''
                        }
                    ],
                    status:'YQR'
                },
                returnData: []
            }
        },
        created(){
            this.returnForm.createUser = JSON.parse(localStorage.getItem('userInfo')).staffName;
            this.$destroy(); //销毁生命周期
            if (!this.$route.query.id) {
                this.orderId = sessionStorage.getItem('saveOrderId');
            }else{
                this.orderId = this.$route.query.id
            }
            this.getWasteInfo();
            this.getWasteInfoList();
        },
        methods: {
            // 汇总数量和金额
            getAllMoney() {
                this.totalCount = 0
                this.totalMoney = 0
                if (this.returnData) {
                    this.returnData.forEach(element => {
                        this.totalCount ++;
                        this.totalMoney = this.totalMoney + element.forecastValue * 1
                    })
                }
            },
            getWasteInfo(){
                wasteInfo({id:this.orderId}).then(res => {
                    if (res.data.status==100) {
                        this.returnForm = res.data.results;
                        this.returnForm.updateTime = this.filters.formatDate(this.returnForm.updateTime);
                        this.returnForm.operatorName = '废料残值';
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            getWasteInfoList(){
                wasteInfoList({id:this.orderId}).then(res => {
                    if (res.data.status==100) {
                        this.returnData = res.data.results.list
                        this.pages.total = res.data.results.total
                        this.getAllMoney()
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getWasteList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getWasteList()
            },
            //返回上一页
            backGo() {
                this.$router.push({
                    path:'/residualManage'
                })
            },
            refresh() {
                this.returnData = []
            },

            tabRemove (targetName) {
                // 首页不可删除
                if(targetName == '/') {
                    return;
                }
                //将该tab从options里移除
                this.$store.commit('delete_tabs', targetName);
                ////还同时需要处理一种情况当需要移除的页面为当前激活的页面时，将上一个tab页作为激活tab
                if (this.activeIndex === targetName) {
                    // 设置当前激活的路由
                    if (this.options && this.options.length >= 1) {
                        this.$store.commit('set_active_index', this.options[this.options.length-1].route);
                        this.$router.push({path: this.activeIndex});
                    } else {
                        this.$router.push({path: '/welcome'});
                    }
                }
            }
        },
        computed: {
        },
        watch: {

        }
    }
</script>

<style type="text/css" lang="scss" scoped>
    #newResidual{
        font-size: 14px;
        .copyBtn{font-size: 24px;cursor: pointer;display:block;float: right;}
        .searthPart{.el-input{width: 100%;}}
        .headerT{font-size: 16px;margin:0 0 15px 0;}
        .activeBtn{background-color: #1abc9c;color:#fff;}
        .eventLi{border-left:1px solid #1abc9c;padding-bottom: 20px;
        .childSpan{padding-left: 20px;margin-bottom: 5px;}
        .childSpan:first-child{padding-left: 0px;margin:-5px 0 0 -5px;}
        .childSpan span.orderId{color: #3399FF;}
        .createTime i{display: block;width: 10px;height: 10px;border-radius: 20px;
            background-color: #1abc9c;margin: 0px 15px 0px -5px;}
        }
        .toolbar{margin: 20px 0;}
        .el-button+.el-button {
            margin-left: 0px;
        }
        .el-step__line{background-color: #1abc9c;}
        .el-step__icon-inner{color:#1abc9c;}
        /*.el-step__icon{width: 10px;height: 10px;}*/
        .el-step__icon.is-text{border-color: #1abc9c;}
        .scanTitle{
            display:block;
            margin:10px
        }
        .priceContent{
            position:relative;
            .el-input__inner{

                padding-left:30px;
                display:block;

            }
            &:before{
                content:"￥";
                display:block;
                width:30px;
                font-size:14px;
                color:#666;
                position:absolute;
                left:0;
                top:0;
                height:32px;
                line-height:32px;
            }
        }
        .dialog-content{
            width:900px;
            margin:0 auto;
            .dialog-code-content{
                text-align: center;
                .el-col{
                    p{
                        border: 1px solid #e3e3e3;
                        line-height: 40px
                    }

                }
            }
        }
        .totalDiv{
            height: auto;
            overflow: hidden;
            text-align: right;
            font-size: 16px;
            background-color: #fff;
            border-bottom: 1px solid #e5e9f2;
            padding: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// residualManageInfo.vue?811f91ae